module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-10 col-xs-offset-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramsLocal),
      expression: "paramsLocal"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.paramsLocal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paramsLocal = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44a207a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/subforms/SearchNumber.vue
// module id = 1099
// module chunks = 0